import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import PropTypes from "prop-types";
import MenuLink from "modules/common/components/MenuLink";

const { AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Box, Flex } = Chakra;

const MenuAccordionItem = ({ label, menu }) => {
  const translations = useTranslations();

  return (
    <AccordionItem>
      <AccordionButton px={8} py={5} bg="greyscale.300" _expanded={{ bg: "white" }}>
        <Box flex="1" textAlign="left" textTransform="uppercase" fontSize="xs" data-testid="footer-category">
          {translations(label)}
        </Box>
        <AccordionIcon boxSize={6} color="primary.500" />
      </AccordionButton>
      <AccordionPanel px={8} pb={3} pt={0} bg="white">
        <Flex direction="column">
          {menu &&
            menu.map((item) => {
              const { label: menuItemLabel } = item;

              return (
                <MenuLink
                  key={menuItemLabel}
                  menuItem={item}
                  variant="footerLight"
                  fontSize="sm"
                  mb={5}
                  data-testid="footer-elements"
                />
              );
            })}
        </Flex>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default MenuAccordionItem;

MenuAccordionItem.propTypes = {
  label: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
